export const baseStyles =
  "font-header font-medium rounded-lg transition duration-300 ease-in-out focus:outline-none";

export const sizeStyles = {
  auto: "py-2 px-4 text-sm w-full",
  small: "py-2 px-8 text-sm w-1/7",
  medium: "py-2 px-8 text-base w-1/7 md:w-1/5",
  large: "py-2 px-8 text-lg w-1/3",
};

export const typeStyles = {
  GradientPrimaryButton:
    "bg-gradient-to-r from-gradientBlueEnd to-gradientBlueStart text-white",
  SolidOrangeButton: "bg-solidOrange text-white",
  SolidGreenButton: "bg-solidGreen text-white",
  SolidBlueButton: "bg-solidBlue text-white",
  OutlineSecondaryButton: "border border-outlineBlue text-outlineBlue",
};

export const disabledStyles = "opacity-70 cursor-not-allowed";

export const linkBtnbaseStyles =
  "font-header font-medium rounded-lg transition duration-300 ease-in-out focus:outline-none py-2 px-8";

export const enabledStyles = "text-outlineBlue";
export const linkBtndisabledStyles =
  "text-outlineBlue opacity-70 cursor-not-allowed";

export const arrowStyles = "ml-1 text-outlineBlue text-sm ";

export const iconLinkBtnbaseStyles =
  "font-header font-medium transition duration-300 ease-in-out focus:outline-none rounded-lg w-full";

export const iconLinkBtnsizeStyles = {
  small: "py-2 px-4 text-sm w-1/7",
  medium: "py-3 px-6 text-md w-1/5",
  large: "py-2 px-4 text-md w-1/3",
};

export const iconLinkBtnenabledStyles = "bg-buttonBgColor text-gray-700";
export const iconLinkBtndisabledStyles =
  "opacity-70 bg-buttonBgColor text-gray-700  cursor-not-allowed text-black";

export const iconLinkBtnarrowStyles = "text-outlineBlue text-sm";

export const dropdownSizeStyles = {
  small: "text-sm w-28 bg-gray-100",
  medium: "text-base w-80",
  large: "text-lg w-full",
};

export const dropdownButtonStyles = `flex items-center justify-between border border-gray-300 rounded-md shadow-sm transition-colors duration-200 p-2`;

export const dropdownMenuStyles =
  "absolute mt-2 bg-white border border-gray-300  rounded-md shadow-lg z-10";

export const optionStyles =
  "flex items-center space-x-3 px-4 py-2 cursor-pointer text-sm text-gray-700 border-b border-gray-200 last:border-0";

export const menuWidthStyles = {
  small: "left-0 right-0 w-auto",
  medium: "w-80",
  large: "w-full",
};

export const multiSelectDropdownsizeStyles = {
  small: "text-sm w-40",
  medium: "text-base w-80",
  large: "text-lg w-full",
};

export const multiSelectDropdownButtonStyles =
  "flex items-center justify-between border border-gray-300 rounded-md shadow-sm transition-colors duration-200 p-2";

export const multiSelectDropdownMenuStyles =
  "absolute mt-2 bg-white border border-gray-300 rounded-md shadow-lg z-10";

export const multiSelectDropdownoptionStyles =
  "flex items-center space-x-3 px-4 py-2 cursor-pointer text-sm text-gray-700 border-b border-gray-200 last:border-0";

export const multiSelectDropdownmenuWidthStyles = {
  small: "w-auto",
  medium: "w-80",
  large: "w-full",
};
